export function hasUnlockUserIntent(userIntent = {}) {
  return Boolean(userIntent?.expectations?.trim());
}

export function buildUnlockCtaPayload({
  source = 'analysis',
  userIntent = null,
  extra = {},
} = {}) {
  return {
    source,
    hasUserIntent: hasUnlockUserIntent(userIntent),
    ...extra,
  };
}
